import { event } from 'vue-analytics';
const actions = {
    // before other modules
    initPre({ state, dispatch, rootState, getters }) { },
    // after all other modules, might be that some config must be loaded only after logged in (scoped by account, etc)
    initPost({ state, commit, getters }) {
        // make sure only available profile id are in the selected list
        commit('setProfileIds', getters.profileIds.filter((v) => getters.availableProfileIds.find((avail) => avail === v)));
    },
    addProfileId({ commit, state }, id) {
        if (undefined == state.profileIds.find((v) => v == id)) {
            const newProfileIds = [id, ...state.profileIds];
            commit('setProfileIds', newProfileIds);
            event('config-store', 'action-addProfileId', id);
        }
    },
    removeProfileId({ commit, state, getters }, id) {
        event('config-store', 'action-removeProfileId', id);
        commit('setProfileIds', state.profileIds.filter((v) => v != id));
    }
};
export default actions;
